import * as FlightStyles from './components/Flight.css';
import { createTheme } from '../utils';

export const defaultTheme = {
	FlightStyles
};

export default defaultTheme;

export const { useTheme } = createTheme<typeof defaultTheme>(defaultTheme);
